export type Testimonial = {
  initials: string
  quote: string
  name: string
  role: string
  location: string
}

export const heroTestimonials: Testimonial[] = [
  {
    initials: 'JR',
    quote:
      'Planifiqué toda mi temporada en una sola tarde. Ahora cada sesión tiene un objetivo claro y mis alumnos notan la diferencia.',
    name: 'Javier R.',
    role: 'Entrenador de Club',
    location: 'Buenos Aires',
  },
  {
    initials: 'CM',
    quote:
      'Mis alumnos progresan mucho más rápido ahora que por fin siguen una progresión lógica.',
    name: 'Coach María',
    role: 'Entrenadora de Academia',
    location: 'Madrid',
  },
  {
    initials: 'SL',
    quote:
      'Ya no pierdo horas buscando ejercicios. Abro Tenis 360 y todo lo que necesito ya está ahí.',
    name: 'Sara L.',
    role: 'Entrenadora Independiente',
    location: 'Ciudad de México',
  },
]

export const testimonials: Testimonial[] = [
  {
    initials: 'JR',
    quote:
      'Planifiqué toda mi temporada en una tarde. Cada sesión tiene un objetivo claro y llego a la cancha sabiendo exactamente qué vamos a hacer.',
    name: 'Javier R.',
    role: 'Entrenador de Club',
    location: 'Buenos Aires, Argentina',
  },
  {
    initials: 'CM',
    quote:
      'Mis alumnos mejoraron más en dos meses que en todo el año anterior. La progresión por fin tiene sentido y ellos lo sienten.',
    name: 'Coach María',
    role: 'Entrenadora de Academia',
    location: 'Madrid, España',
  },
  {
    initials: 'SL',
    quote:
      'Antes pasaba horas buscando ejercicios en internet. Ahora abro Tenis 360 y tengo todo lo que necesito.',
    name: 'Sara L.',
    role: 'Entrenadora Independiente',
    location: 'Ciudad de México, México',
  },
  {
    initials: 'DT',
    quote:
      'Las fichas de evaluación cambiaron por completo cómo hablo con los padres. Ahora hablo con datos y confían en el proceso.',
    name: 'Diego T.',
    role: 'Entrenador Principal',
    location: 'Santiago, Chile',
  },
  {
    initials: 'EV',
    quote:
      'Como entrenadora en mi primer año estaba totalmente desbordada. Tenis 360 me dio un sistema profesional completo desde el día uno.',
    name: 'Elena V.',
    role: 'Entrenadora Sub-12 Femenino',
    location: 'Bogotá, Colombia',
  },
  {
    initials: 'RB',
    quote:
      'El volumen de vuelta tras lesión salvó a uno de mis mejores alumnos. Supe exactamente qué hacer y volvió a la cancha con seguridad en 6 semanas.',
    name: 'Rubén B.',
    role: 'Entrenador Senior',
    location: 'Valencia, España',
  },
]
